import React, { useCallback, useEffect, useState } from "react";
import { enqueueSnackbar } from "notistack";
import GridContainer from "../../../../componentsv2/GridContainer";
import GridItem from "../../../../componentsv2/GridItem";
import Button from "../../../../componentsv2/Button";
import { Input } from "../../../../componentsv2/Input";
import { api } from "../../../../services/Api";

export default function ObservacoesClinicas({
  clienteId,
  somenteLeitura = false,
  onDescricaoChange,
}) {
  const [observacoesIds, setObservacoesIds] = useState([]);
  const [observacaoAtualId, setObservacaoAtualId] = useState(null);
  const [descricao, setDescricao] = useState("");

  const carregarObservacoes = useCallback(
    async id => {
      if (!id) {
        setObservacoesIds([]);
        setObservacaoAtualId(null);
        setDescricao("");
        onDescricaoChange?.("");
        return;
      }

      try {
        const {
          data: { data },
        } = await api.get(`/v2/agendaCare/cliente/${id}/observacoes`);
        const observacoes = data || [];
        const primeiraObservacao = observacoes[0];

        setObservacoesIds(observacoes.map(observacao => observacao.id));
        setObservacaoAtualId(primeiraObservacao?.id || null);
        const texto = primeiraObservacao?.descricao || "";
        setDescricao(texto);
        onDescricaoChange?.(texto);
      } catch (error) {
        enqueueSnackbar("Erro ao carregar observações do cliente!", { variant: "error" });
      }
    },
    [onDescricaoChange]
  );

  useEffect(() => {
    carregarObservacoes(clienteId);
  }, [clienteId, carregarObservacoes]);

  const salvarObservacao = async () => {
    if (!clienteId) {
      return;
    }

    const descricaoTrim = descricao.trim();

    try {
      if (descricaoTrim && observacaoAtualId) {
        await api.patch(`/v2/agendaCare/cliente/${clienteId}/observacoes/${observacaoAtualId}`, {
          descricao: descricaoTrim,
        });
      } else if (descricaoTrim && !observacaoAtualId) {
        await api.post(`/v2/agendaCare/cliente/${clienteId}/observacoes`, {
          descricao: descricaoTrim,
        });
      } else if (!descricaoTrim && observacoesIds.length > 0) {
        await Promise.all(
          observacoesIds.map(observacaoId =>
            api.delete(`/v2/agendaCare/cliente/${clienteId}/observacoes/${observacaoId}`)
          )
        );
      }

      await carregarObservacoes(clienteId);

      if (!descricaoTrim && observacoesIds.length > 0) {
        enqueueSnackbar("Observações do cliente removidas!", { variant: "success" });
        return;
      }

      if (descricaoTrim) {
        enqueueSnackbar("Observações do cliente salvas com sucesso!", { variant: "success" });
      }
    } catch (error) {
      const mensagem =
        error?.response?.data?.messages || "Erro ao salvar observações do cliente!";
      enqueueSnackbar(mensagem, { variant: "error" });
    }
  };

  if (!clienteId) {
    return null;
  }

  return (
    <div style={{ marginTop: "12px" }}>
      <GridContainer spacing={2}>
        <GridItem xs={12}>
          <span style={{ fontSize: "14px", fontWeight: 600, color: "#5f6b7a" }}>
            Observações do cliente
          </span>
        </GridItem>
        {somenteLeitura ? (
          <GridItem xs={12}>
            {descricao ? (
              <p style={{ fontSize: "14px", color: "#424242", whiteSpace: "pre-wrap", margin: 0 }}>
                {descricao}
              </p>
            ) : (
              <span style={{ fontSize: "13px", color: "#999" }}>Nenhuma observação registrada.</span>
            )}
          </GridItem>
        ) : (
          <>
            <GridItem xs={12}>
              <Input
                variant="outlined"
                fullWidth
                multiline
                minRows={4}
                placeholder="Digite observações relevantes sobre o cliente..."
                value={descricao}
                onChange={event => {
                  const valor = event.target.value;
                  setDescricao(valor);
                  onDescricaoChange?.(valor);
                }}
              />
            </GridItem>
            <GridItem xs={12} style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}>
              <Button color="blue" variant="contained" onClick={salvarObservacao}>
                Salvar
              </Button>
            </GridItem>
          </>
        )}
      </GridContainer>
    </div>
  );
}
